import { Location } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Component, HostListener, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomAttachFilesComponent } from 'src/app/components/custom-attach-files/custom-attach-files.component';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { ClientStateEnums } from 'src/app/enum/client-state-enums';
import { ConstructionSiteStateEnums } from 'src/app/enum/construction-site-enums';
import { GeneralParameterEnums } from 'src/app/enum/general-parameter-enums';
import { ServiceStateEnums } from 'src/app/enum/service-state-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { ServicePrintModel } from 'src/app/models/rental/service-print-model';
import { ServiceModel } from 'src/app/models/rental/service.model';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InvoiceService } from 'src/app/services/invoicing/invoice.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { OrderService } from 'src/app/services/preliminaries/order.service';
import { ServiceService } from 'src/app/services/rental/service.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-register-service',
  templateUrl: './register-service.component.html',
  styleUrls: ['./register-service.component.scss'],
  standalone: false
})
export class RegisterServiceComponent implements OnInit, OnDestroy {

  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly branchService = inject(BranchService);
  private readonly confirmDialogService = inject(ConfirmDialogService);
  private readonly dateConverterService = inject(DateConverterService);
  private readonly formBuilder = inject(FormBuilder);
  private readonly formControlStateService = inject(FormControlStateService);
  private readonly headerService = inject(HeaderService);
  private readonly invoiceService = inject(InvoiceService);
  private readonly location = inject(Location);
  private readonly optionWindowService = inject(OptionWindowService);
  private readonly router = inject(Router);
  private readonly serviceService = inject(ServiceService);
  private readonly toastHandlerService = inject(ToastHandlerService);
  private readonly title = inject(Title);
  private readonly orderService = inject(OrderService);
  private readonly userAuthenticatedService = inject(UserAuthenticatedService);
  private readonly windowService = inject(WindowService);

  @ViewChild('attachFileService') attachFileServiceComponent?: CustomModalComponent | null = null;
  branchId = 0;
  clientStateActive: number = ClientStateEnums.activo;
  clientStateId: number = ClientStateEnums.activo;
  companyId: number = 0;
  componentAttachFiles = CustomAttachFilesComponent;
  consecutiveOrder: string = '';
  constructionSiteStateId: number = ConstructionSiteStateEnums.activa;
  defaultStoreIdForBranch: number | null = null;
  disabledDetail: boolean = false;
  disabledForm: boolean = false;
  filteredCostCenters: any[] = [];
  formService: FormGroup = new FormGroup({});
  iconStateService: string = 'pi pi-lock-open';
  inputsForAttachFiles$ = new BehaviorSubject<any>({
    listFiles: [],
    labelConsecutive: 0,
    disabled: false
  });
  invoicingCutoffCode: number | string = '';
  isCreatingServiceFromOrder: boolean = false;
  isOpened: string | undefined = undefined;
  listBranch: any[] = [];
  listClients: any[] = [];
  listCostCenter: any[] = [];
  listFiles: any[] = [];
  listObservers: Subscription[] = [];
  listTypeCutoffMovement: any[] = [
    { label: 'Movimiento', value: true },
    { label: 'Servicio', value: false }
  ];
  nameWindow: string = 'Captura Servicios';
  outputForAttachFiles$ = new Subject<any>();
  permissionPrint: boolean = false;
  permissionUpdatable: boolean = false;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  projectName = ProjectName.projectName;
  quantityDetails: number = 0;
  reloadPrint: boolean = false;
  serviceContract: ServiceModel = new ServiceModel();
  serviceId: number = 0;
  servicePrintModel: ServicePrintModel = new ServicePrintModel();
  serviceStateOpen: number = ServiceStateEnums.abierto;
  serviceStateString: string = '';
  severityState: string = "danger";
  subscription: Subscription;
  swfacturacionEspecial: boolean = false;
  swOrder: boolean = false;
  swServiceRequiresOrder: boolean = false;
  swServicesFullSeparately: boolean = false;
  swToInvoiceServiceSeparately: boolean = false;
  swTypeService: boolean = false;
  titleStateService: string = 'Cerrar';
  url: string = 'service';
  userAuthenticated: UserModel = new UserModel();

  async ngOnInit() {
    this.validateForm(new ServiceModel());
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.serviceId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.handleInitialState();

    this.subscription = this.outputForAttachFiles$.subscribe(async ({ type, payload }) => {
      switch (type) {
        case 'uploadFile':
          this.uploadFile(payload);
          break;
        case 'downloadFile':
          this.downloadFile(payload);
          break;
        case 'deleteFile':
          this.deleteFile(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    this.listObservers.forEach(sub => sub.unsubscribe());
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  async annulService() {
    const service = this.serviceContract;
    if (!service?.serviceId) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un Servicio.'
      );
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para anular servicios. Comuníquese con el administrador del sistema.'
      );
      return;
    }
    if (service.swBlock) {
      this.toastHandlerService.showToast(
        'warning',
        'El servicio se encuentra bloqueado.'
      );
      return;
    }
    if (service.serviceStateId === ServiceStateEnums.anulado) {
      this.toastHandlerService.showToast(
        'warning',
        'El servicio se encuentra anulado.'
      );
      return;
    }
    const accepted = await this.confirmDialogService.confirm('¿Realmente desea anular el servicio actual?');
    if (accepted) {
      try {
        this.serviceContract = await firstValueFrom(this.serviceService.annulService(this.serviceId));
        this.validateForm(this.serviceContract);
        this.toastHandlerService.showToast('success', 'El servicio fue anulado exitosamente.', '');
      } catch (error) {
        console.error("Error al anular el servicio.", error);
      }
    }
  }

  async blockService(value: boolean) {
    const serviceId = this.serviceContract?.serviceId;
    if (!serviceId) {
      setTimeout(() => this.formService.get("swBlock")?.setValue(!value));
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un Servicio.');
      return;
    }
    try {
      this.serviceContract = await firstValueFrom(this.serviceService.blockService(serviceId));
      this.validateForm(this.serviceContract);
      this.toastHandlerService.showToast(
        'success',
        `Servicio ${value ? 'bloqueado' : 'desbloqueado'} correctamente.`
      );
    } catch (error) {
      setTimeout(() => this.formService.get("swBlock")?.setValue(!value));
      console.error("Error al bloquear el servicio.", error);
    }
  }

  async changeBranch(branchId: number, loadAllLists: boolean) {
    this.branchId = branchId;
    if (loadAllLists) {
      await this.getAllLists();
    } else {
      await this.getAllLists('costCenters');
      this.resetContract();
    }
    this.getDefaultStoreForBranch();
  }

  async changeConsecutive() {
    const branchId = this.formService.get("branchId")?.value;
    let consecutive = this.formService.get("consecutive")?.value;
    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una Sucursal.'
      );
      return;
    }
    if (consecutive == "" || consecutive == null) consecutive = 0;

    if (consecutive == null) {
      this.serviceId = 0;
      const modelService = new ServiceModel();
      modelService.branchId = branchId;
      this.serviceContract = modelService;
    } else {
      try {
        this.serviceContract = await firstValueFrom(this.serviceService.getServiceByKeysAsync(branchId, consecutive));
        this.serviceId = this.serviceContract.serviceId;
        this.validateForm(this.serviceContract);
        this.location.replaceState(`/service/register/${this.serviceId}`);
      } catch (error) {
        this.formService.controls["consecutive"].setValue(this.serviceContract.consecutive);
        console.error("Error al buscar el servicio por claves.", error);
      }
    }
  }

  async changeStateService() {
    const serviceId = this.serviceContract?.serviceId;
    if (!serviceId) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un Servicio.'
      );
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para cambiar estados de servicios. Comuníquese con el administrador del sistema.'
      );
      return;
    }
    if (this.serviceContract.swBlock) {
      this.toastHandlerService.showToast(
        'warning',
        'El servicio se encuentra bloqueado.'
      );
      return;
    }
    try {
      this.serviceContract = await firstValueFrom(this.serviceService.setStateService(serviceId));
      this.validateForm(this.serviceContract);
    } catch (error) {
      console.error("Error al cambiar el estado del servicio.", error);
    }
  }

  changeValues() {
    this.disabledDetail = true;
  }

  async createNewService() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        `El usuario no tiene permisos para crear servicios. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    this.resetContract();
    if (this.swServiceRequiresOrder) {
      this.openOrderModal();
    }
  }

  async changeSwOrder(swOrder: boolean) {
    const swOrderControl = this.formService.get('swOrder');
    if (swOrder && !this.swServiceRequiresOrder) {
      setTimeout(() => swOrderControl?.patchValue(false));
      this.toastHandlerService.showToast(
        'info',
        `No puede activar “Req. Pedido”: la compañia no tiene esta opción habilitada. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    if ((this.serviceContract?.swOrder != swOrder) && this.quantityDetails > 0) {
      setTimeout(() => swOrderControl?.patchValue(this.serviceContract?.swOrder));
      this.toastHandlerService.showToast(
        'error',
        `No es posible cambiar el estado de la opción “Req. Pedido” mientras el servicio tenga detalles registrados.`
      );
      return;
    }
    if (!swOrder && this.formService.get('orderId')?.value) {
      const accepted = await this.confirmDialogService.confirm(
        'Al deshabilitar esta opción, el servicio se desvinculará del pedido actual. ¿Desea continuar?'
      );
      if (!accepted) {
        setTimeout(() => this.formService.get('swOrder')?.patchValue(true));
        return;
      }
      this.consecutiveOrder = '';
      this.formService.controls['orderId'].patchValue(null);
    }
  }

  async createService(model: ServiceModel) {
    try {
      this.serviceContract = await firstValueFrom(this.serviceService.createService(model));
      this.serviceId = this.serviceContract.serviceId;
      this.validateForm(this.serviceContract);
      this.location.replaceState(`/${this.url}/register/${this.serviceId}`);
      this.toastHandlerService.showToast(
        'success',
        'El servicio fue creado exitosamente.'
      );
    } catch (error) {
      console.error('Error al crear un nuevo servicio.', error);
    }
  }

  async deleteFile(file: any) {
    const serviceId = this.serviceContract?.serviceId;
    if (!serviceId) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe existir un servicio para gestionar adjuntos.'
      );
      return;
    }
    const accepted = await this.confirmDialogService.confirm('¿Realmente desea eliminar el adjunto seleccionado?');
    if (accepted) {
      try {
        await firstValueFrom(this.serviceService.deleteFilesToService(serviceId, file));
        this.toastHandlerService.showToast(
          'success',
          'El adjunto fue eliminado exitosamente'
        );
        this.getFilesToService();
      } catch (error) {
        console.error('Error al eliminar el archivo.', error);
      }
    }
  }

  async deleteService() {
    const service = this.serviceContract;
    if (!service?.serviceId) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un Servicio.'
      );
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para eliminar servicios. Comuníquese con el administrador del sistema.'
      );
      return;
    }
    if (service.swBlock) {
      this.toastHandlerService.showToast(
        'warning',
        'El servicio se encuentra bloqueado.'
      );
      return;
    }
    if (service.serviceStateId !== ServiceStateEnums.abierto) {
      this.toastHandlerService.showToast(
        'warning',
        'Para eliminar el servicio debe estar en estado Abierto.'
      );
      return;
    }
    const accepted = await this.confirmDialogService.confirm('¿Realmente desea eliminar el servicio actual?');
    if (accepted) {
      try {
        await firstValueFrom(this.serviceService.deleteService(this.serviceId));
        this.toastHandlerService.showToast(
          'success',
          'El servicio fue eliminado exitosamente.'
        );
        this.resetContract();
      } catch (error) {
        console.error("Error al eliminar el servicio.", error);
      }
    }
  }

  downloadFile(fileName: any) {
    if (this.serviceContract.serviceId != 0) {
      this.serviceService.downloadFileToService(this.serviceContract.serviceId, fileName).subscribe(data => {
        switch (data.type) {
          case HttpEventType.Response: {
            const downloadedFile = new Blob([data.body!], { type: data.body!.type });
            const a = document.createElement('a');
            a.setAttribute('style', 'display:none;');
            document.body.appendChild(a);
            a.download = fileName;
            a.href = URL.createObjectURL(downloadedFile);
            a.target = '_blank';
            a.click();
            document.body.removeChild(a);
            break;
          }
        }
      });
    }
  }

  finishLoading(finishPrint: boolean) {
    if (finishPrint) window.print();
  }

  async getAllLists(...listsToLoad: Array<'branches' | 'costCenters' | 'clients'>) {
    try {
      const lists = {
        branches: async () => {
          this.listBranch = await firstValueFrom(this.serviceService.getAllBranchesForSelectAsync());
        },
        costCenters: async () => {
          this.listCostCenter = await firstValueFrom(this.serviceService.getAllCostCenterByBranchForSelect(this.branchId));
          this.filteredCostCenters = this.listCostCenter;
        },
        clients: async () => {
          this.listClients = await firstValueFrom(this.serviceService.getAllClientsForSelectAsync());
        }
      };
      if (listsToLoad.length) {
        await Promise.all(listsToLoad.map(list => lists[list]()));
      } else {
        await Promise.all([
          lists.branches(),
          lists.costCenters(),
          lists.clients()
        ]);
      }
    } catch (error) {
      console.error('Error obtener las listas.', error);
    }
  }

  async getButtonClick(buttonClick: any) {
    const branchId = this.formService.get("branchId")?.value;
    let consecutive = this.formService.get("consecutive")?.value;
    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una Sucursal.', 'Atención');
      return;
    }
    if (consecutive == "" || consecutive == null) consecutive = 0;

    switch (buttonClick.target.id) {
      case 'first': {
        try {
          this.serviceContract = await firstValueFrom(this.serviceService.getFirstServiceByKeysAsync(branchId));
          this.validateForm(this.serviceContract);
          this.serviceId = this.serviceContract.serviceId;
          this.location.replaceState(`/service/register/${this.serviceId}`);
        } catch (error) {
          console.error('Error al buscar el primer servicio por claves.', error);
        }
        break;
      }
      case 'previus': {
        try {
          this.serviceContract = await firstValueFrom(this.serviceService.getPreviusServiceByKeysAsync(branchId, consecutive));
          this.validateForm(this.serviceContract);
          this.serviceId = this.serviceContract.serviceId;
          this.location.replaceState(`/service/register/${this.serviceId}`);
        } catch (error) {
          console.error('Error al buscar el servicio anterior por claves.', error);
        }
        break;
      }
      case 'next': {
        try {
          this.serviceContract = await firstValueFrom(this.serviceService.getNextServiceByKeysAsync(branchId, consecutive));
          this.validateForm(this.serviceContract);
          this.serviceId = this.serviceContract.serviceId;
          this.location.replaceState(`/service/register/${this.serviceId}`);
        } catch (error) {
          console.error('Error al buscar el siguiente servicio por claves.', error);
        }
        break;
      }
      case 'last': {
        try {
          this.serviceContract = await firstValueFrom(this.serviceService.getLastServiceByKeysAsync(branchId));
          this.validateForm(this.serviceContract);
          this.serviceId = this.serviceContract.serviceId;
          this.location.replaceState(`/service/register/${this.serviceId}`);
        } catch (error) {
          console.error('Error al buscar el último servicio por claves.', error);
        }
        break;
      }
    }
  }

  async getClient(clientId: number | null) {
    try {
      const hasDetails = this.quantityDetails > 0;
      const previousClientId = this.serviceContract.costCenter?.clientId;
      const hasActiveOrder = this.serviceContract.swOrder && (this.serviceContract.orderId ?? 0) > 0;
      if (hasDetails && clientId !== previousClientId) {
        const message = !clientId ? 'No puede limpiar el cliente si el servicio tiene detalle.'
          : 'No puede cambiar el cliente si el servicio tiene detalle.';
        this.toastHandlerService.showToast('error', message, 'Error');
        setTimeout(() => this.formService.controls["clientId"].patchValue(previousClientId));
        return;
      }
      if (hasActiveOrder && clientId !== previousClientId) {
        const accepted = await this.confirmDialogService.confirm(
          'Al cambiar el cliente, el servicio se desvinculará del pedido actual. ¿Desea continuar?'
        );
        if (!accepted) {
          setTimeout(() => this.formService.get("clientId")?.patchValue(previousClientId));
          return;
        }
        this.consecutiveOrder = "";
        this.serviceContract.orderId = null;
        this.serviceContract.swOrder = false;
        this.formService.patchValue({
          swOrder: false,
          orderId: null
        });
      }
      if (!clientId) {
        this.filteredCostCenters = this.listCostCenter;
        setTimeout(() => this.formService.get("costCenterId")?.patchValue(null));
        return;
      }
      if (clientId !== previousClientId) {
        setTimeout(() => this.formService.get("costCenterId")?.patchValue(null));
      }
      this.filteredCostCenters = this.listCostCenter.filter(cc => cc.clientId === clientId);
      const client = await firstValueFrom(this.invoiceService.getClientByIdForRegisterInvoiceAsync(clientId));
      this.clientStateId = client.clientStateId;
      if (client.clientStateId === ClientStateEnums.inactivo) {
        this.toastHandlerService.showToast(
          'warning',
          'El cliente seleccionado se encuentra inactivo.'
        );
        this.formService.patchValue({ clientId: null, costCenterId: null });
        this.filteredCostCenters = this.listCostCenter;
      }
    } catch (error) {
      console.error('Error al obtener el cliente.', error);
    }
  }

  getClassCostCenter(): string {
    return this.constructionSiteStateId === 1 ? '' : 'state-inactive';
  }

  async getCostCenter(costCenterId: number | null, isInitialLoad: boolean) {
    try {
      const previousCostCenterId = this.serviceContract.costCenterId;
      const hasDetails = this.quantityDetails > 0;
      const hasActiveOrder = this.serviceContract.swOrder && (this.serviceContract.orderId ?? 0) > 0;
      if (!isInitialLoad && hasDetails && costCenterId !== previousCostCenterId) {
        const msg = !costCenterId ? 'No puede limpiar el centro de costos si el servicio tiene detalle.'
          : 'No puede cambiar el centro de costos si el servicio tiene detalle.';
        this.toastHandlerService.showToast('error', msg);
        setTimeout(() => this.formService.get("costCenterId")?.patchValue(previousCostCenterId));
        return;
      }
      console.warn('Intento de cambio de centro de costos con detalles registrados.', previousCostCenterId);
      if (!isInitialLoad && hasActiveOrder && costCenterId !== previousCostCenterId) {
        const accepted = await this.confirmDialogService.confirm(
          'Al cambiar el centro de costos, el servicio se desvinculará del pedido actual. ¿Desea continuar?'
        );
        if (!accepted) {
          setTimeout(() => this.formService.get("costCenterId")?.patchValue(previousCostCenterId));
          return;
        }
        this.consecutiveOrder = "";
        this.serviceContract.orderId = null;
        this.serviceContract.swOrder = false;
        setTimeout(() =>
          this.formService.patchValue({
            swOrder: false,
            orderId: null
          })
        );
      }
      if (!costCenterId) {
        const clientId = this.formService.get("clientId")?.value;
        setTimeout(() =>
          this.formService.patchValue({
            costCenterId: null,
            sellerId: null
          })
        );
        this.filteredCostCenters = clientId ? this.listCostCenter.filter(cc => cc.clientId === clientId) : this.listCostCenter;
        return;
      }
      const response = await firstValueFrom(this.serviceService.getCostCenterByIdAsync(costCenterId));
      if (!isInitialLoad && response.constructionSiteStateId === ConstructionSiteStateEnums.inactiva) {
        this.toastHandlerService.showToast(
          'warning',
          'El centro de costos seleccionado se encuentra inactivo.'
        );
        setTimeout(() =>
          this.formService.patchValue({
            costCenterId: null,
            clientId: null,
            sellerId: null
          })
        );
        this.filteredCostCenters = this.listCostCenter;
        return;
      }
      this.constructionSiteStateId = response.constructionSiteStateId;
      this.clientStateId = response.clientStateId;
      this.filteredCostCenters = this.listCostCenter.filter(cc => cc.clientId === response.clientId);
      if (this.formService.get("clientId")?.value !== response.clientId) {
        this.formService.get("clientId")?.patchValue(response.clientId);
      }
      setTimeout(() => this.formService.get("costCenterId")?.patchValue(costCenterId));
    } catch (error) {
      console.error('Error al obtener el centro de costos.', error);
    }
  }

  getDefaultStoreForBranch() {
    const branch = this.listBranch.find(x => x.value === this.branchId);
    if (branch) {
      this.defaultStoreIdForBranch = branch.swBranchStore ? branch.storeId : 0;
    }
  }

  async getFilesToService() {
    try {
      this.listFiles = await firstValueFrom(this.serviceService.getFilesToService(this.serviceId));
      this.updateInputsForAttachFiles();
    } catch (error) {
      console.error('Error catch:', error);
    }
  }

  async getFirstBranchByUserAuthenticated() {
    try {
      const response = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      this.companyId = response.companyId;
      await this.changeBranch(response.branchId, true);
    } catch (error) {
      console.error('Error al obtener la sucursal del usuario.', error);
    }
  }

  async getGeneralParametersByCompany() {
    const load = this.userAuthenticatedService.generalParameterObservable.subscribe(response => {
      this.swTypeService = response.some(x => x.generalParameterId === GeneralParameterEnums.tipoServicio);
      this.swToInvoiceServiceSeparately = response.some(x => x.generalParameterId === GeneralParameterEnums.facturaServiciosAparte);
      this.swServicesFullSeparately = response.some(x => x.generalParameterId === GeneralParameterEnums.serviciosFullAparte);
      this.swfacturacionEspecial = response.some(x => x.generalParameterId === GeneralParameterEnums.facturacionEspecial);
      this.swOrder = this.swServiceRequiresOrder = response.some(x => x.generalParameterId === GeneralParameterEnums.servicioRequierePedido);
    });
    if (this.swTypeService) {
      setTimeout(() => this.formService.controls["isTypeCutoffMovement"].enable());
    } else {
      setTimeout(() => this.formService.controls["isTypeCutoffMovement"].disable());
    }
    this.listObservers.push(load);
  }

  async getInvoicingCutoffCode(invoicingCutoffId: number | null) {
    if (!invoicingCutoffId) {
      this.invoicingCutoffCode = "";
      return;
    }
    try {
      const response = await firstValueFrom(this.invoiceService.getInvoicingCutoffCodeByIdAsync(invoicingCutoffId));
      this.invoicingCutoffCode = response ?? "";
    } catch (error) {
      this.invoicingCutoffCode = "";
      console.error("Error al obtener el código de corte.", error);
    }
  }

  async getOrderConsecutive(orderId: number | null) {
    if (!orderId) {
      this.consecutiveOrder = "";
      return;
    }
    try {
      const response = await firstValueFrom(this.orderService.getOrderConsecutiveById(orderId));
      this.consecutiveOrder = `${response ?? ""}`;
    } catch (error) {
      this.consecutiveOrder = "";
      console.error("Error al obtener el código de corte.", error);
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'warning',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    this.getUserAuthenticated();
    this.getGeneralParametersByCompany();
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      this.getPermissionsForServiceWindow();
      this.getPermissionPrint();
    } catch (error) {
      console.error('Error al obtener los permisos del perfil.', error);
    }
  }

  async getPermissionPrint() {
    try {
      this.permissionPrint = await firstValueFrom(this.serviceService.getPermissionPrint());
    } catch (error) {
      console.error('Error al obtener el permiso de impresión.', error);
    }
  }

  async getUserAuthenticated() {
    const load = this.userAuthenticatedService.userObservable.pipe(filter(user => user && user.userId !== 0))
      .subscribe(user => {
        this.userAuthenticated = user;
        this.companyId = user.companyId;
      });
    this.listObservers.push(load);
  }

  async getPermissionsForServiceWindow() {
    try {
      this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.Service));
    } catch (error) {
      console.error('Error al obtener los permisos del usuario para la ventana Service.', error);
    }
  }

  async getServiceById() {
    try {
      const response = await firstValueFrom(this.serviceService.getServiceById(this.serviceId));
      await this.changeBranch(response.branchId, true);
      this.serviceContract = response;
      this.serviceId = response.serviceId;
      this.validateForm(this.serviceContract);
    } catch (error) {
      console.error('Error al obtener el servicio por ID.', error);
    }
  }

  goToBack(event: Event) {
    event.preventDefault();
    this.router.navigate(['/service']);
  }

  async handleInitialState() {
    if (this.serviceId !== null && this.serviceId !== 0) {
      this.formService.enable();
      await this.getServiceById();
    } else {
      await this.getFirstBranchByUserAuthenticated();
      this.createNewService();
    }
  }

  async onServiceUpdate(serviceContract: ServiceModel) {
    this.serviceId = serviceContract.serviceId;
    Object.assign(this.serviceContract, serviceContract);
    this.location.replaceState(`/${this.url}/register/${this.serviceId}`);
    await this.validateForm(serviceContract);
  }

  async openAttachFile() {
    const serviceId = this.serviceContract?.serviceId;
    if (!serviceId) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un servicio.'
      );
      return;
    }
    await this.getFilesToService();
    this.attachFileServiceComponent?.show();
  }

  openOrderModal() {
    const service = this.serviceContract;
    if (service?.serviceStateId !== ServiceStateEnums.abierto) {
      this.toastHandlerService.showToast(
        'warning',
        'Para ingresar a la selección de pedidos el servicio debe estar en estado Abierto.'
      );
      return;
    }
    if (service?.swBlock) {
      this.toastHandlerService.showToast(
        'warning',
        'El servicio se encuentra bloqueado.'
      );
      return;
    }
    if (!this.swServiceRequiresOrder) {
      this.toastHandlerService.showToast(
        'info',
        `No puede seleccionar pedidos: la compañía no tiene esta opción habilitada. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    if (this.quantityDetails > 0) {
      this.toastHandlerService.showToast(
        'error',
        `No es posible ingresar a la selección de pedidos mientras el servicio tenga detalles registrados.`
      );
      return;
    }
    this.isCreatingServiceFromOrder = !this.isCreatingServiceFromOrder;
  }

  async printPage() {
    const serviceId = this.serviceContract?.serviceId;
    if (!serviceId) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un servicio.'
      );
      return;
    }
    if (!this.permissionPrint) {
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para imprimir servicios. Comuníquese con el administrador del sistema.'
      );
      return;
    }
    try {
      this.toastHandlerService.clearAllToasts();
      const { branchId } = this.serviceContract;
      const response = await firstValueFrom(this.serviceService.getServiceByKeysByPrintAsync(branchId, 0, serviceId));
      this.servicePrintModel = response;
      this.reloadPrint = !this.reloadPrint;
    } catch (error) {
      console.error('Error al imprimir el servicio.', error);
    }
  }

  async resetContract() {
    this.disabledDetail = true;
    this.serviceId = 0;
    this.quantityDetails = 0;
    this.consecutiveOrder = "";
    this.invoicingCutoffCode = "";
    this.clientStateId = ClientStateEnums.activo;
    this.constructionSiteStateId = ConstructionSiteStateEnums.activa;
    this.serviceContract = new ServiceModel();
    this.serviceContract.branchId = this.branchId;
    this.serviceContract.swOrder = this.swServiceRequiresOrder;
    this.serviceContract.swInvoiceSeparately = this.swToInvoiceServiceSeparately;
    this.serviceContract.isTypeCutoffMovement = !this.swServicesFullSeparately;
    this.validateForm(this.serviceContract);
    this.location.replaceState(`/service/register`);
  }

  async send() {
    this.validateFormControls();
    if (!this.formService.valid) {
      this.showValidationMessages();
      return;
    }
    const modelService = this.formService.getRawValue() as ServiceModel;
    if (!this.swTypeService) {
      this.formService.controls['isTypeCutoffMovement'].disable();
    }
    if (modelService.invoicingCutoffId === 0) modelService.invoicingCutoffId = null;
    if (modelService.observation?.trim() === "") modelService.observation = null;
    if (this.serviceId === 0) {
      await this.createService(modelService);
    } else {
      await this.updateService(modelService);
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      branchId: {
        required: 'El campo Sucursal es obligatorio.'
      },
      dateService: {
        required: 'El campo Fecha es obligatorio.'
      },
      serviceStateId: {
        required: 'El campo Estado es obligatorio.'
      },
      costCenterId: {
        required: 'El campo C.Costos es obligatorio.',
        min: 'Debes seleccionar un C.Costos válido.'
      },
      observation: {
        maxlength: 'El campo Observación no puede tener más de 250 caracteres.'
      }
    };

    Object.keys(controlMessages).forEach(control => {
      const formControl = this.formService.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  updateFormState() {
    const stateId = this.serviceContract.serviceStateId;
    const statesConfig: any = {
      [ServiceStateEnums.abierto]: {
        text: "Abierto",
        icon: 'pi pi-lock-open',
        title: "Cerrar",
        severity: 'danger'
      },
      [ServiceStateEnums.anulado]: {
        text: "Anulado",
        icon: 'pi pi-lock',
        title: "Abrir",
        severity: 'warn'
      },
      [ServiceStateEnums.cerrado]: {
        text: "Cerrado",
        icon: 'pi pi-lock',
        title: "Abrir",
        severity: 'success'
      },
      [ServiceStateEnums.impreso]: {
        text: "Impreso",
        icon: 'pi pi-lock',
        title: "Abrir",
        severity: 'success'
      }
    };
    const config = statesConfig[stateId];
    if (config) {
      const { text, icon, title, severity } = config;
      this.serviceStateString = text;
      this.iconStateService = icon;
      this.titleStateService = title;
      this.severityState = severity;
    }
    const isEditable = stateId === ServiceStateEnums.abierto &&
      !this.serviceContract.swBlock && this.permissionUpdatable;
    this.disabledForm = this.disabledDetail = !isEditable;
    setTimeout(() => {
      const form = this.formService;
      const controls = form.controls;
      controls['orderId'].disable();
      if (isEditable) {
        form.enable();
        this.serviceId ? controls['consecutive'].enable() : controls['consecutive'].disable();
        if (!this.swTypeService) {
          controls['isTypeCutoffMovement'].disable();
        }
      } else {
        form.disable();
        const controlDisable: string[] = ['branchId', 'consecutive', 'swBlock'];
        setTimeout(() =>
          this.formControlStateService.setControlState(form, controlDisable, true)
        );
      }
    });
  }

  updateInputsForAttachFiles() {
    this.inputsForAttachFiles$.next({
      listFiles: this.listFiles,
      labelConsecutive: this.serviceContract.consecutive,
      disabled: this.serviceContract.serviceStateId != ServiceStateEnums.abierto
    });
  }

  async uploadFile(formData: any) {
    try {
      await firstValueFrom(this.serviceService.attachFilesToService(this.serviceId, formData));
      await this.getFilesToService();
      this.toastHandlerService.showToast(
        'success',
        'Se adjunto el archivo exitosamente'
      );
    } catch (error) {
      console.error('Error al adjuntar el archivo.', error);
    }
  }

  async updateService(model: ServiceModel) {
    this.serviceContract.costCenterId = model.costCenterId;
    this.serviceContract.alterNumber = model.alterNumber;
    this.serviceContract.swOrder = model.swOrder;
    this.serviceContract.orderId = model.orderId;
    this.serviceContract.dateService = model.dateService;
    this.serviceContract.isTypeCutoffMovement = model.isTypeCutoffMovement;
    this.serviceContract.swInvoiceSeparately = model.swInvoiceSeparately;
    this.serviceContract.observation = model.observation;
    try {
      this.serviceContract = await firstValueFrom(this.serviceService.updateService(this.serviceContract));
      this.serviceId = this.serviceContract.serviceId;
      this.validateForm(this.serviceContract);
      this.toastHandlerService.showToast(
        'success',
        'El servicio fue actualizado exitosamente.'
      );
    } catch (error) {
      console.error('Error al actualizar el servicio.', error);
    }
  }

  async validateForm(service: ServiceModel) {
    this.formService = this.formBuilder.group({
      branchId: [service.branchId, [Validators.required, Validators.min(1)]],
      consecutive: [service.consecutive],
      alterNumber: [service.alterNumber],
      clientId: [0],
      dateService: [service.dateService ? this.dateConverterService.convertUtcToLocalDate(service.dateService)
        : null, [Validators.required]],
      serviceStateId: [service.serviceStateId, [Validators.required]],
      isTypeCutoffMovement: [service.isTypeCutoffMovement],
      swInvoiceSeparately: [service.swInvoiceSeparately],
      costCenterId: [service.costCenterId, [Validators.required, Validators.min(1)]],
      orderId: [service.orderId],
      swBlock: [service.swBlock],
      swOrder: [service.swOrder],
      observation: [service.observation, [Validators.maxLength(250)]]
    });
    this.updateFormState();
    await this.getCostCenter(service.costCenterId, true);
    if (service.serviceId) {
      await Promise.all([
        this.getOrderConsecutive(service.orderId),
        this.getInvoicingCutoffCode(service.invoicingCutoffId)
      ]);
    }
  }

  validateFormControls() {
    Object.keys(this.formService.controls).forEach((key) => {
      const control = this.formService.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
